// Human-readable label for a backend enum value ("FULL_TIME" → "Full Time").
// Display-only: the raw enum is still what gets stored and sent to the backend.

// Tokens the generic word-capitalization rule gets wrong — acronyms that stay
// all-caps (HR) and brand casing (DevOps). Keyed by the raw enum value; add new
// irregulars here so every surface formats them identically.
const IRREGULAR_LABELS = {
    HR: 'HR',
    DEVOPS: 'DevOps',
};

export const formatEnumValue = (value) => {
    if (!value) return 'N/A';
    const irregular = IRREGULAR_LABELS[value.toUpperCase()];
    if (irregular) return irregular;
    return value
        .split('_')
        .map(word => word.charAt(0) + word.slice(1).toLowerCase())
        .join(' ');
};
